import { createSelector } from '@reduxjs/toolkit';
import { assetsWithTasks } from './assets-with-tasks';

export const assetsDiscardedWithTasks = createSelector(assetsWithTasks, function (assets) {
  return assets.filter(function (item) {
    return item.discardedYear !== '';
  });
});
